(function () {
  'use strict';
  angular
    .module('frontendapp', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.bootstrap',
      'ui.router',
      'toastr',
      'LocalStorageModule',
       'satellizer',
      'sap.imageloader',
      'angular-inview',
      'ngMap',
      'fox.scrollReveal',
      'angularSmoothscroll',
      'angular-owl-carousel-2',
      'angular-loading-bar',
      'swipe',
      '720kb.socialshare'
    ]);

})();

'use strict';
angular
  .module('frontendapp')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      webcontent: function (tabla, params) {
        params['lan'] = 'en';
        return $http.get($rootScope.api + '/webcontent', params);
      },
      getcontent: function (table, params) {
        params['lan'] =   $rootScope.language;
        return $http.post($rootScope.api + '/api/' + table + '/getcontent', params);
      },
      webform: function (table, params) {
        params['lan'] =   $rootScope.language;
        return $http.post($rootScope.api + '/api/' + table + '/webform', params);
      },
    };
  });

'use strict';
angular
  .module('frontendapp')
  .factory('ContentService', function ($http, $rootScope, $log) {
    return {

      getdata: function (tabla, params) {
        $log.log('GETDATA PARAMS', tabla, params);
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },

      websearch: function ( params) {
        $log.log('WEBSEARCH PARAMS', params);
        return $http.post($rootScope.api + '/api/websearch', params);
      },

      webcontent: function (state, params) {
        params['state'] = state;
        $log.log('WEBCONTENT PARAMS', params);
        return $http.post($rootScope.api + '/api/webcontent', params);
      },

      sendform: function (params) {
        return $http.post($rootScope.api + '/api/sendform', params);
      }


    };
  });

(function() {
  'use strict';

  angular
      .module('frontendapp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('frontendapp')
    //establece altura a pantalla completa
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            console.log('exit')
          }).resize();
        }
      };
    })
    //establece altura a pantalla completa
    .directive('windowheight2', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            element.css({height: $(window).height()});
            element.css({maxHeight: $(window).height()});
            console.log('exit')
          }).resize();
        }
      };
    })
    //Iguala altura entre elementos
    //targetclass = nombre de la clase para igualar alturas de elementos
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          targetclass: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            console.log(scope.targetclass)
            $timeout(function () {
              var x = document.getElementsByClassName(scope.targetclass);
              var temp = 0;
              for (var i = 0; i < x.length; i++){
                if(temp < x[i].offsetHeight){
                  temp = x[i].offsetHeight;
                }
              }
              console.log('maximo altura detectada',  temp);
              element.css({minHeight: temp});
            }, 1000);
          }).resize();
        }
      };
    })
    //establece una altura personalizada partiendo del alto de pantalla o deua medida especifica
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          autoscroll: '=',
          lockscroll:'='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            element.css({minHeight: customHeight });
            if (scope.autoscroll == true) {
              element.css({maxHeight: customHeight});
              element.css({overflowY: 'scroll'});
            }
            element.css({minHeight: customHeight});
            if(scope.lockscroll==true){
              element.css({maxHeight: customHeight});
              element.css({overflow: 'hidden'});
            }
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="width:100%;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })

})();

/**
 * Created by DELL on 6/8/2018.
 */
angular
  .module('frontendapp')
  .controller('tarotCtrl', function ( $rootScope, $scope) {
    var vm = this;



    console.log('tarotCtrl', $rootScope.currentUser)
    vm.ok = function () {
     // $uibModalInstance.close();
    };
    vm.cancel = function () {
     // $uibModalInstance.dismiss('cancel');
    };
  });

/**
 * Created by DELL on 6/8/2018.
 */
angular
  .module('frontendapp')
  .controller('numbersCtrl', function ($rootScope) {
  var vm = this;

    $rootScope.setName = function (value) {
      $rootScope.currentUsername = value;
    }
    /*$rootScope.currentUser = {
     name : $rootScope.currentUser.name
     }*/
   /* $rootScope.ok = function () {
      $uibModalInstance.close();
    };
    $rootScope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };*/
});

'use strict';
angular
  .module('frontendapp')
  .controller('kaleCtrl', function (ImageLoader,$window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('kaleCtrl');

    var config = {
      bgcolor: "#000",
      color1: "#24b8cd",
      color2: "#735689",
      color3: "#E4E224",
      //fade: 0.5,
      fade: 0.8,
      fill: false,
      gain: 0.03,
      groupSize: 5,
      lineWidth: 1,
      mirrors: 5.0,
      num: 32,
      opacity: 0.3,
      //opacity: 0.07,
      overlap: 1.001,
      rotation: 0.5,
      shape: "circle",
      size:2,
      spacing: 0.2,
      speed: 0.1,
      stroke: true,
      strokeColor: "#ffffff",
      wavelength: 2.5,
      wires: false,
      zoom: -0.15
    };

    // create a target config for easing
    var targetConfig = angular.copy(config);
    var currentTime = 0;

    // ease into these
    config.rotation = 0;
    config.size = 0;
    //config.num = 0;
    config.fade = 0;
    config.speed = 0;

    // export targetConfig for console accesibility
    window.targetConfig = targetConfig;
    window.config = config;

    // our canvas and drawing context
    var canvas = document.getElementById('my-canvas');
    var mainCtx = canvas.getContext('2d');
    var bufferCanvas = document.createElement('canvas');
    var bufferCtx = bufferCanvas.getContext('2d');
    var textureCanvas = document.createElement('canvas');
    var textureCtx = textureCanvas.getContext('2d');
    textureCanvas.width = bufferCanvas.width = canvas.width;
    textureCanvas.height = bufferCanvas.height = canvas.height;

    window.mainCtx = mainCtx;
//    mainCtx.fillStyle = "rgba(0, 0, 0, 0.5)";

    // our height and width constants
    var W = canvas.width;
    var H = canvas.height;
    var CX = W / 2;
    var CY = H / 2;
    var PI2 = 2 * Math.PI;

    var shapes = {
      circle: drawCircle,
      triangle: drawTriangle,
      square: drawSquare
    };

    // init background color
    //updateBackground();

    // init GUI
    var gui = new dat.GUI();
    gui.add(targetConfig, 'opacity', 0, 1.0);
    gui.add(targetConfig, 'fade', 0, 1.0);
    gui.add(targetConfig, 'speed', -.5, 1);
    gui.add(targetConfig, 'num', 1, 50);
    gui.add(targetConfig, 'groupSize', 1, 50);
    gui.add(targetConfig, 'overlap', -2, 2);
    gui.add(targetConfig, 'mirrors', 1, 7);
    gui.add(targetConfig, 'size', 0, 10);
    gui.add(targetConfig, 'spacing', 0.01, 10);
    gui.add(targetConfig, 'wavelength', 0.01, 10);
    gui.add(targetConfig, 'lineWidth', 0, 10);
    gui.add(targetConfig, 'zoom', -2, 2);
    gui.add(targetConfig, 'rotation', -1, 1);
    gui.add(targetConfig, 'shape', _.keys(shapes));
    gui.add(targetConfig, 'fill');
    gui.add(targetConfig, 'stroke');
    gui.add(targetConfig, 'wires');

    gui.addColor(targetConfig, 'bgcolor').onChange(updateBackground);
    gui.addColor(targetConfig, 'strokeColor');
    gui.addColor(targetConfig, 'color1');
    gui.addColor(targetConfig, 'color2');
    gui.addColor(targetConfig, 'color3');

    gui.add({'Make GIF': startRecording},'Make GIF');
    gui.close();

    render(0);


    var gif;

    setTimeout(function() {
     // gif = giffer(W,H);
     // gif.config.maxFrames = 90;
     // gif.config.delay = 60;
    }, 1000);

    function startRecording() {
      if(gif) {
        gif.startStop();
      }
    }



    function draw(ctx, t, n) {

      var color_index = (1 + Math.floor(n / config.groupSize) % 3);
      var color = config['color' + color_index];
      var rotation = t / 2000;

      ctx.save();
      ctx.translate(CX, CY);
      ctx.rotate(rotation);
      ctx.strokeStyle = config.strokeColor;
      ctx.fillStyle = color;
      ctx.lineWidth = config.lineWidth;

      // Some Magic Numbers
      var ss = config.wavelength;
      var size = config.size / 10 * (
        (1 + Math.sin(t / 911 * ss)) * CX * .3 +
        (1 + Math.cos(t / 701 * ss)) * CX * .2 +
        (1 + Math.sin(t / 503 * ss)) * CX * .1)
      var x = Math.sin(t / (n + 787) * ss) * CX * .37;
      var y = Math.sin(t / (n + 997) * ss) * CY * .13;

      // Draw the shape
      shapes[config.shape](ctx, x, y, size);

      if (config.fill)
        ctx.fill();

      if (config.stroke)
        ctx.stroke();

      ctx.restore();
    }

    function drawCircle(ctx, x, y, r) {
      r = Math.abs(r);
      ctx.save();
      ctx.beginPath();
      ctx.arc(x, y, r, 0, PI2);
      ctx.restore();
    }

    function drawTriangle(ctx, x, y, size) {
      ctx.save();
      ctx.translate(x, y);
      ctx.beginPath();
      ctx.moveTo(0, size);
      ctx.lineTo(size / 2, 0);
      ctx.lineTo(-size / 2, 0);
      ctx.lineTo(0, size);
      ctx.restore();
    }

    function drawSquare(ctx, x, y, size) {
      ctx.save();
      ctx.translate(x, y);
      ctx.beginPath();
      ctx.moveTo(0, size);
      ctx.lineTo(size, size);
      ctx.lineTo(size, 0);
      ctx.lineTo(0, 0);
      ctx.lineTo(0, size);
      ctx.restore();
    }

    var t = Math.random() * 100000 >> 0;
    var super_rotation = Math.random() * PI2;

    function render() {

      t += config.speed * 10;
      super_rotation += PI2 * (config.rotation/1000);

      // clear the buffer
      bufferCtx.clearRect(0, 0, W, H);
      textureCtx.clearRect(0, 0, W, H);

      var seg = Math.pow( 2, Math.ceil(targetConfig.mirrors) );

      // draw the last frame back at semi-opacity (for trails)
      bufferCtx.globalAlpha = config.fade;

      // zoom and rotate the buffer around the center as we draw it back
      bufferCtx.save();
      bufferCtx.translate(CX, CY);
      bufferCtx.scale(1 + config.zoom / 100, 1 + config.zoom / 100);
      bufferCtx.rotate(config.rotation / 100); // this is counter to the rendered rotation
      bufferCtx.translate(-CX, -CY);

      // capture last frame to buffer
      bufferCtx.drawImage(canvas, 0, 0);
      bufferCtx.restore();

      // mask a pie Shape
      textureCtx.save();
      textureCtx.translate(CX, CY);
      textureCtx.beginPath();
      textureCtx.moveTo(0, 0);
      textureCtx.arc(0, 0, W, 0, (PI2 / seg) *  (1+config.overlap)); // overlap
      textureCtx.lineTo(0, 0);
      // textureCtx.fillStyle = 'rgba(0,100,0,0.1)';
      // textureCtx.fill();
      // //textureCtx.stroke();
      textureCtx.clip();
      textureCtx.translate(-CX, -CY);

      // draw to the buffer at desired opacity level
      textureCtx.globalAlpha = config.opacity;

      // Do some drawing of things to the texture
      for (var n = 0; n < config.num; n++) {
        var ti = t + n * config.spacing * 1000;
        draw(textureCtx, ti, n);
      }

      textureCtx.restore();



      // // // draw debug rect
      if(config.wires) {
        textureCtx.globalAlpha = config.opacity/2;
        textureCtx.save();
        textureCtx.translate(CX, CY);
        textureCtx.beginPath();
        textureCtx.strokeStyle = config.strokeColor;
        textureCtx.lineWidth = config.lineWidth/config.mirrors;
        var pad = CX / 15;
        for (var n = 0; n < 4; n++) {
          var p = pad * Math.pow((n)/5, .5);
          textureCtx.save();
          textureCtx.scale(2, 2);
          textureCtx.strokeRect(p, p, W - p * 2, H - p * 2);
          //textureCtx.translate(-W, -H);
          //textureCtx.strokeRect(p, p, W - p * 2, H - p * 2);
          textureCtx.translate(0, -H);
          //textureCtx.strokeRect(p, p, W - p * 2, H - p * 2);
          textureCtx.restore();
        }
        textureCtx.restore();
      }

      // Draw back on itself (This is our only 'mirror')
      textureCtx.globalAlpha = 1.0
      textureCtx.save();
      textureCtx.translate(0, H);
      textureCtx.scale(1, -1);
      textureCtx.drawImage(textureCanvas, 0, 0, W, H);
      textureCtx.restore();



      bufferCtx.save();
      bufferCtx.globalAlpha = 1.0;
      bufferCtx.translate(CX, CY);
      bufferCtx.rotate(super_rotation);
      bufferCtx.scale(1.5, 1.5);
      //bufferCtx.scale(config.zoom, config.zoom);
      bufferCtx.translate(-CX, -CY);

      var s = seg / 2;

      // draw the texture to the buffer in kaleidoscope fashion
      for (var r = 0; r < s; r++) {

        // scale and rotate from the center
        bufferCtx.translate(CX, CY);
        //bufferCtx.scale(1 + config.zoom/100, 1 + config.zoom/100);
        bufferCtx.rotate(PI2 / s);

        bufferCtx.translate(-CX, -CY);

        // But just draw a portion of it
        bufferCtx.drawImage(textureCanvas, 0, 0, W, H, 0, 0, W, H);

      }

      bufferCtx.restore();

      // Fill the canvas so we have a background color in image exports
      mainCtx.save();
      //mainCtx.fillStyle = '#efefef';
      mainCtx.clearRect(0, 0, canvas.width, canvas.height);
      mainCtx.translate(CX, CY);
      mainCtx.translate(-CX, -CY);
      mainCtx.drawImage(bufferCanvas, 0, 0);
      mainCtx.restore();

      /*
      var background = new Image();
      background.src = "http://localhost:3000/assets/images/harb.jpg";
      //mainCtx.drawImage(background,0,0);
      background.onload = function(){
        mainCtx.drawImage(background,0,0);
        mainCtx.drawImage(bufferCanvas, 0, 0);
        mainCtx.fillStyle = "rgba(0, 0, 0, 0.5)";
        mainCtx.restore();
        //console.log('ejecuta')
      }();
      */

      if(gif && gif.isRecording()) {
        gif.captureFrame(mainCtx.canvas);
      }

      requestAnimationFrame(render);

      // ease our config values to their targets
      easeObject(config, targetConfig, config.gain);
    }

    function updateBackground(val) {
      $('body, canvas').css('backgroundColor', val || config.bgcolor);
    }

    // Ease a single value towards another value by some gain percentage
    function ease(val, to, gain) {
      return val + (to - val) * gain;
    }

    // Ease all the numeric properties of an object to the
    // value of the same property on a target object
    function easeObject(obj, targetObj, gain) {
      gain = gain || .03;
      _.each(obj, function(val, prop) {
        if (_.isNumber(val)) {
          obj[prop] = ease(val, targetObj[prop], gain);
        } else {
          obj[prop] = targetObj[prop];
        }
      });
    }

  });

'use strict';
angular
  .module('frontendapp')
  .controller('HomeController', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('HomeController');


    $rootScope.kandaWakeUp = function (scene) {
      //$rootScope.isNavCollapsed = true;

      $rootScope.kandaVoice = document.getElementById(scene);
      $rootScope.currentScene = $rootScope.kandaScene[scene];
      $rootScope.currentScene.status = 'on';
      $rootScope.kandaReady = false;
      $rootScope.kandaVoice.play();
      window.markDate = new Date();
      $rootScope.updateClock();
    };
    $rootScope.updateClock = function () {
      var currDate = new Date();
      var diff = currDate - markDate;
      $rootScope.currentScene.elapsed = format(diff / 1000);
      $rootScope.currentScene.time = angular.copy($rootScope.currentScene.elapsed.toString());
      $rootScope.currentScene.time = parseInt($rootScope.currentScene.time.split(':')[2]);
      console.log('updateClock', $rootScope.currentScene.time);
      $rootScope.currentScene.textOff = true;
      angular.forEach($rootScope.currentScene.data, function (i) {
        if ((i.start) <= $rootScope.currentScene.time && i.end >= $rootScope.currentScene.time) {
          $rootScope.currentScene.text = i.text;
          console.log('updateClock text', $rootScope.currentScene.text);
          $rootScope.currentScene.textOff = false;
          $rootScope.kandaSpeaking = true;
        }
      });
      if ($rootScope.currentScene.textOff == true || $rootScope.kandaReady===true) {
        $rootScope.currentScene.text = '';
        $rootScope.kandaSpeaking = false;
      }
      $timeout(function () {
        if ($rootScope.currentScene.duration >= $rootScope.currentScene.time) {
          $rootScope.updateClock();
        }
        else {
          $rootScope.currentScene.status = 'off';
        }
        //$rootScope.updateClock ();
      }, 1000);
    };
    function format(seconds) {
      var numhours = parseInt(Math.floor(((seconds % 31536000) % 86400) / 3600), 10);
      var numminutes = parseInt(Math.floor((((seconds % 31536000) % 86400) % 3600) / 60), 10);
      var numseconds = parseInt((((seconds % 31536000) % 86400) % 3600) % 60, 10);
      return ((numhours < 10) ? "0" + numhours : numhours)
        + ":" + ((numminutes < 10) ? "0" + numminutes : numminutes)
        + ":" + ((numseconds < 10) ? "0" + numseconds : numseconds);
    }

    $rootScope.kandaScene = {
      intro: {
        status: false,
        duration: 15,
        data: [
          {
            text: 'Bienvenido a la mágica experiencia de KANDA',
            start: 0,
            end: 2
          },
          {
            text: 'Una senda facinante y atractiva',
            start: 3,
            end: 5
          },
          {
            text: 'Por la cual te guiaré a conocer los misterios del universo',
            start: 5,
            end: 8
          },
          {
            text: 'y la magia de tu yo interior',
            start: 9,
            end: 11
          },
          {
            text: 'empecemos esta experiencia con tu nombre',
            start: 12,
            end: 14
          }
        ]
      }
    };


  });

'use strict';
angular
  .module('frontendapp')
  .controller('blogController', function (ImageLoader, $window,  $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('blogController');

    vm.categories = [
      {id:1, nombre:'Categoria 1', imagen: '../assets/images/foto-content-1.jpg'},
      {id:2, nombre:'Categoria 2',imagen:  '../assets/images/foto-content-2.jpg'},
      {id:3, nombre:'Categoria 3', imagen: '../assets/images/foto-content-3.jpg'},
      {id:4, nombre:'Categoria 4', imagen: '../assets/images/foto-content-4.jpg'},
    ]


  });


angular.
  module('frontendapp').
  controller('ModalDemoCtrl', function ($uibModal, $log, $document) {
  var $ctrl = this;
  $ctrl.items = ['item1', 'item2', 'item3'];

  $ctrl.animationsEnabled = true;

  $ctrl.open = function (size, parentSelector) {
    var parentElem = parentSelector ?
      angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;
    var modalInstance = $uibModal.open({
      animation: $ctrl.animationsEnabled,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      templateUrl: 'myModalContent.html',
      controller: 'ModalInstanceCtrl',
      controllerAs: '$ctrl',
      size: size,
      appendTo: parentElem,
      resolve: {
        items: function () {
          return $ctrl.items;
        }
      }
    });

    modalInstance.result.then(function (selectedItem) {
      $ctrl.selected = selectedItem;
    }, function () {
      $log.info('Modal dismissed at: ' + new Date());
    });
  };

  $ctrl.openComponentModal = function () {
    var modalInstance = $uibModal.open({
      animation: $ctrl.animationsEnabled,
      component: 'modalComponent',
      resolve: {
        items: function () {
          return $ctrl.items;
        }
      }
    });

    modalInstance.result.then(function (selectedItem) {
      $ctrl.selected = selectedItem;
    }, function () {
      $log.info('modal-component dismissed at: ' + new Date());
    });
  };

  $ctrl.openMultipleModals = function () {
    $uibModal.open({
      animation: $ctrl.animationsEnabled,
      ariaLabelledBy: 'modal-title-bottom',
      ariaDescribedBy: 'modal-body-bottom',
      templateUrl: 'stackedModal.html',
      size: 'sm',
      controller: function($scope) {
        $scope.name = 'bottom';
      }
    });

    $uibModal.open({
      animation: $ctrl.animationsEnabled,
      ariaLabelledBy: 'modal-title-top',
      ariaDescribedBy: 'modal-body-top',
      templateUrl: 'stackedModal.html',
      size: 'sm',
      controller: function($scope) {
        $scope.name = 'top';
      }
    });
  };

  $ctrl.toggleAnimation = function () {
    $ctrl.animationsEnabled = !$ctrl.animationsEnabled;
  };
});

// Please note that $uibModalInstance represents a modal window (instance) dependency.
// It is not the same as the $uibModal service used above.
/*

angular.module('frontendapp').controller('ModalInstanceCtrl', function ($uibModalInstance, items) {
  var $ctrl = this;
  $ctrl.items = items;
  $ctrl.selected = {
    item: $ctrl.items[0]
  };

  $ctrl.ok = function () {
    $uibModalInstance.close($ctrl.selected.item);
  };

  $ctrl.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
});

// Please note that the close and dismiss bindings are from $uibModalInstance.

angular.module('frontendapp').component('modalComponent', {
  templateUrl: 'myModalContent.html',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: function () {
    var $ctrl = this;

    $ctrl.$onInit = function () {
      $ctrl.items = $ctrl.resolve.items;
      $ctrl.selected = {
        item: $ctrl.items[0]
      };
    };

    $ctrl.ok = function () {
      $ctrl.close({$value: $ctrl.selected.item});
    };

    $ctrl.cancel = function () {
      $ctrl.dismiss({$value: 'cancel'});
    };
  }
});
*/

'use strict';
angular
  .module('frontendapp')
  .controller('AppController', function ($log, TablesService, $rootScope, $timeout, toastr, $sce) {
    var vm = this;
    $log.debug('AppController');

    /************  DEFAULT CONFIGURATIONS ************/
    $rootScope.defaultOwlConf = {
      items: 1,
      nav: false,
      // startPosition:parseInt(index),
      loop: true,
      autoplay: false,
      autoPlaySpeed: 5000,
      autoPlayTimeout: 5000,
      autoplayHoverPause: true,
      navText: ['<span><i class="fas fa-chevron-up"></i></span>', '<span><i class="fas fa-chevron-down"></i></span>'],
    };
    $rootScope.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    }
    $rootScope.audioFix = function (audio) {
      $rootScope.trustSrc($rootScope.api + audio.location);
      if(audio.location){
        $rootScope.trustSrc($rootScope.api + audio.location);
        var exit =  $rootScope.trustSrc($rootScope.api + audio.location);;
        return exit;
      }
      else{
        return '';
      }
    };

    /********  MODALS AND WEB FORMS ********/
    $rootScope.modals = {
      currentModal: ''
    };
    $rootScope.modalTab = 1;
    $rootScope.showModal = function (modal, value) {
      console.log(modal);
      $rootScope.currentModal = modal;
      $rootScope.modals.currentModal = 'app/views/modals/' + modal + '.html';
      $rootScope.modalTab = 1;
      $rootScope.formData = {};
      $rootScope.searched = [];
      $rootScope.validateRequest();
      $rootScope.playAudioEffect('whoosh_02');
      //$rootScope.isNavCollapsed = true;
    };
    $rootScope.formDataHome = {};
    $rootScope.closeModal = function () {
      $rootScope.modals.currentModal = '';
      $rootScope.modalTab = 1;
      $rootScope.playAudioEffect('whoosh_02');
    };
    $rootScope.$watch('modals', function () {
      if ($rootScope.modals.currentModal != '') {
        document.body.style.overflow = 'hidden';
      }
      else {
        document.body.style.overflow = 'initial';
      }
    }, true);
    $rootScope.navModals = function (value) {
      switch (value) {
        case 'prev':
          if ($rootScope.modalTab > 1) {
            $rootScope.modalTab--;
          }
          break;
        case 'next':
          $rootScope.modalTab++;
          $timeout(function () {
            if ($rootScope.currentModal != 'modalpresskit') {
              $rootScope.closeModal();
            }
          }, 5000);
          break;
        default:
          $rootScope.modalTab = value;
          break;
      }
    };
    $rootScope.$watch('modals', function () {
      $log.log('actualiza modals', $rootScope.modals)
    }, true);
    //recaptcha
    function onloadCallback() {
     /* grecaptcha.ready(function () {
        grecaptcha.execute('6LfvLrgUAAAAAKwr9FHjRABHKfH6oLyQ6bzMldo0', {action: 'contact'})
          .then(function (token) {
            //$log.log('CAPTCHA', token);
            $rootScope.gc = token;
          });
      });*/
    }
    $rootScope.validateRequest = function () {
      onloadCallback();
    };
    $rootScope.sendForm = function (id, data, flash) {
      $log.log('ingresa', id, data);
      if (id && data) {
        $log.log('ingresa 0');

        var params = {
          mailingcategory_id: id,
          gc: $rootScope.gc,
          fields: data
        };
        $log.log('params', params);
        ContentService.sendform(params)
          .success(function (res) {
            $log.log('sendform res', res);
            if (res.status) {
              $rootScope.navModals('next');
              $log.log('sendform', res)
            }
            else {
              toastr.warning('Please try again', 'Connection error');
            }
          });
      }
      else {
        $log.log('ingresa 1');
        $rootScope.navModals('next');
      }
      if (flash) {
        toastr.success($rootScope.sT('Mensaje enviado', 'Message sent'), 'Success');
      }
    };
    $rootScope.terms = false;
    $rootScope.showTerms = function(){
      $rootScope.terms = !$rootScope.terms ;
    }

    /******** HELPER *******/
    $rootScope.kandaHelp = false;
    $rootScope.showKandaHelp = function (){
      $rootScope.kandaHelp = !$rootScope.kandaHelp ;
    };

    /******** NOTIFICATIONS *******/
    $rootScope.showNots = true;
    $rootScope.setNots = function (){
      $rootScope.showNots = !$rootScope.showNots ;
    };

    /******** TAROT INTERACTION *******/
    $rootScope.deckReady = false;
    $rootScope.startDeck= function () {
      $timeout(function () {
        $rootScope.step = 1;
        $rootScope.picked = null;
        $rootScope.deckReady = true;
        $rootScope.playAudioEffect('whoosh_03');
      }, 1000);
    };
    $rootScope.deck = [];
    for(var i = 1; i <=20; i ++ ){
      $rootScope.deck.push({
        imagen:'assets/images/card.jpg',
        id:i,
        nombre:'carta'+i+''
      })
    }
    $rootScope.pickCard=function (card){
      $rootScope.playAudioEffect('whoosh_06');
      var rnd = Math.floor(Math.random() * ($rootScope.webcontent.webtarot.length));
      console.log('RANDOM', rnd, $rootScope.webcontent.webtarot.length);
      $rootScope.picked = $rootScope.webcontent.webtarot[rnd];
    };
    $rootScope.step = 1;
    $rootScope.next = function (){
      $rootScope.step = 2;
    };
    $rootScope.setName = function (value) {
      $rootScope.currentUser.name = value;
    };

    /************** NUMEROLOGY INTERACTIONS *************/
    $rootScope.magicNumbers = function (){
      $rootScope.modalTab = 2;
      console.log('FECHA DE NACIMIENTO', $rootScope.currentUser.birthdate);
      console.log('FECHA DE NACIMIENTO', $rootScope.currentUser.birthdate.toString());
      console.log('YEAR', $rootScope.currentUser.birthdate.getFullYear());
      console.log('MONTH', $rootScope.currentUser.birthdate.getMonth());
      console.log('DATE', $rootScope.currentUser.birthdate.getDate());

      var year =  $rootScope.currentUser.birthdate.getFullYear();
      var month =  $rootScope.currentUser.birthdate.getMonth()+1;
      var day = $rootScope.currentUser.birthdate.getDate();
      var temp1 = 0;
      temp1 += $rootScope.sumByDigit(year);
      temp1 += $rootScope.sumByDigit(month);
      temp1 += $rootScope.sumByDigit(day);
      console.log('temp1', temp1);
      if(temp1>9 && temp1 != 11 && temp1 != 22 && temp1 != 33 ){
        var temp2 = $rootScope.sumByDigit(temp1);
        console.log('temp2', temp2);
        if(temp2>9 && temp2 != 11 && temp2 != 22 && temp2 != 33){
          var temp3 = $rootScope.sumByDigit(temp3);
          console.log('temp3', temp3);
          if(temp3>9 && temp3 != 11 && temp3 != 22 && temp3 != 33){
            var temp4 = $rootScope.sumByDigit(temp4);
            console.log('temp4', temp4);
            $rootScope.currentUser.magic = temp4;
          }
          else{
            $rootScope.currentUser.magic = temp3;
          }
        }
        else{
          $rootScope.currentUser.magic = temp2;
        }
      }
      else{
        $rootScope.currentUser.magic = temp1;
      }

      angular.forEach($rootScope.webcontent.webnumerology, function (i) {
        if( parseInt(i.name) === $rootScope.currentUser.magic  ){
          $rootScope.numpick = i;
        }
      });
      console.log('MAGIC', $rootScope.currentUser.magic)
    };
    $rootScope.sumByDigit = function(source){
      var digits = (""+source).split("");
      var exit = 0;
      angular.forEach(digits, function (i) {
        exit += parseInt(i) ;
      });
      return exit;
    }

  });

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, localStorageService, $timeout, $window, ContentService, $stateParams) {

    //$rootScope.api = 'http://localhost:8000';
    $rootScope.api = 'http://kanda.aknatechnologies.com/restapi/public';

    $rootScope.language = 'en';

    $rootScope.getSessionParam = function (key) {
      return localStorageService.get(key);
    };

    $rootScope.setSessionParam = function (key, val) {
      return localStorageService.set(key, val);
    };

    $rootScope.switchText = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };
    $rootScope.sT = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };

    $rootScope.changeLanguage = function (value, state) {
      $rootScope.language = value;
      $rootScope.setSessionParam('language', value);
      $state.go(state, {lan: value});
    };

    $rootScope.isNavCollapsed = true;
    $rootScope.isCollapsed = false;
    $rootScope.isCollapsedHorizontal = false;

    $rootScope.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };

    $rootScope.stateGo= function (state, params){
      $state.go(state, params)
    };
    $rootScope.stateGoParent= function (){
      $state.go('^')
    };

    $rootScope.kandaDefaultB = '../assets/images/kanda/texture4.jpg';
    $rootScope.kandaSpeaking = false;
    $rootScope.kandaHover = false;
    $rootScope.kandaReady = false;
    $rootScope.kandaTransition = false;

    $rootScope.kandaChange = function (value) {
      console.log('cambia');
      console.log($rootScope.kandaDefaultB);
      //document.body.style.background = "url('"+value+"') no-repeat center top";
      if (value) {
        document.getElementById('ball').style.background = "url('" + value + "') repeat center top";
        document.getElementById("ball").style.WebkitAnimation = "back2 10s linear forwards";
        $rootScope.kandaHover = true;
      }
      else {
        value = $rootScope.kandaDefaultB;
        document.getElementById("ball").style.WebkitAnimation = "back1 30s linear infinite";
        document.getElementById('ball').style.background = "url('" + value + "') repeat center top";
        $rootScope.kandaHover = false;
      }
    };

    $rootScope.currentUser={
      name:'',
      lastname:'',
    };


    /************  AUDIO CONFIGURATIONS ************/
    /*************** VOICE EFFECTS  **************/

    $rootScope.playAudioVoice = function (audio) {
      $rootScope.audioVoice = document.getElementById(audio);
      $rootScope.audioVoice.play();
      $rootScope.kandaSpeaking = true;
      $rootScope.tempAudio = angular.copy(audio);
      $rootScope.audioVoice.onended = function() {
        $rootScope.statusAudioVoice($rootScope.tempAudio, true);
        $rootScope.kandaSpeaking = false
      };
    };
    $rootScope.statusAudioVoice = function (audio, force) {
      if(force){
        return false;
      }
      $rootScope.audioVoice = document.getElementById(audio);
      if ($rootScope.audioVoice && $rootScope.audioVoice.paused ) {
        $rootScope.kandaSpeaking = false;
        return 'off';
      }
      else {
        return 'on';
      }
    };
    $rootScope.stopAudioVoice = function (audio) {
      $rootScope.audioVoice = document.getElementById(audio);
      $rootScope.audioVoice.pause();
      $rootScope.kandaSpeaking = false;

    };

    /*************** SOUND EFFECTS  **************/
    $rootScope.playAudioEffect = function (audio) {
      $rootScope.audioEffect = document.getElementById(audio);
      $rootScope.audioEffect.play();
    };


    $rootScope.introScene=function(){
      console.log('akna ready');
      //$rootScope.playAudioEffect('bell_2');
      $rootScope.playAudioEffect('bell_1');
      $rootScope.kandaReady = true;
      $rootScope.kandaTransition = true;
      $rootScope.setSessionParam ('currentUser', $rootScope.currentUser);
      $timeout(function(){
        $rootScope.kandaTransition = false;
      },1000);
    };

    $rootScope.wrapperMenu = false;
    $rootScope.showMenu = function (){
      $rootScope.wrapperMenu = !$rootScope.wrapperMenu ;
      if($rootScope.wrapperMenu===true){
        $rootScope.playAudioEffect('whoosh_02');
      }
      else {
        $rootScope.playAudioEffect('whoosh_01');
      }
    };

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      $("html, body").animate({scrollTop: 0}, 1000);
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.stateParams = $stateParams;
      $rootScope.currentState = $state.current.name;

      if($rootScope.currentState != 'home'){
        $rootScope.wrapperMenu = true;
        $rootScope.kandaReady = true;
      }
      //$rootScope.kandaReady = true;
      $rootScope.kandaHelp = false;
      ($rootScope.getSessionParam('language')) ? $rootScope.language = $rootScope.getSessionParam('language') : $rootScope.language = 'es';
      console.log('webcontent!!');
      ContentService.webcontent($rootScope.currentState, $stateParams)
        .success(function (res) {
          $timeout(function () {
            $rootScope.playAudioEffect('bell_1');
          }, 1000);
          if (res.status) {
            $rootScope.webcontent = res.result;
            console.log('webcontent!!', $rootScope.webcontent);
            switch ($rootScope.currentState) {
              case 'home':
              default:
                $timeout(function () {
                  $rootScope.showLoader = false;
                }, 5000);
                break;
            }
            console.log('WC FINAL', $rootScope.wc);
          }
        });
      $rootScope.kandaChange();
      $rootScope.currentUser = $rootScope.getSessionParam ('currentUser');
    });

    $rootScope.getImageArray = function (source, target) {
      var imageArray = [];
      angular.forEach(source, function (value, key) {
        if (value[target]) {
          imageArray.push($rootScope.api + value[target]);
        }
      });
      return imageArray;
    };

    $rootScope.preLoader = function (imageArray) {
      ImageLoader.loadImages(imageArray).then(function (loadedStrings) {
        $rootScope.imageStringsList = loadedStrings;
        $log.log($rootScope.imageStringsList);
        $rootScope.showLoader = false;
      });
    };

    $rootScope.fixNameUrl = function (link) {
      return encodeURI(link);
    };

    $rootScope.decodeNameUrl = function (link) {
      return decodeURIComponent(link);
    };
    $rootScope.audio = document.getElementById("waves");

    $rootScope.audioButton = true;

    $rootScope.stopAudio = function () {
      if ($rootScope.audio && $rootScope.audio.paused) {
        $rootScope.audio.play();
        $rootScope.audioButton = true;
      }
      else {
        $rootScope.audio = document.getElementById("waves");
        $rootScope.audio.pause();
        $rootScope.audioButton = false;
      }
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/views/home/main.html',
        controller: 'HomeController',
        controllerAs: 'ini'
      })
      .state('blog', {
        url: 'blog/:collection',
        parent :'home',
        templateUrl: 'app/views/blog/category.html',
        controller: 'blogController',
        controllerAs: 'blog'
      })
      .state('detail', {
        url: '/:alias',
        parent :'blog',
        templateUrl: 'app/views/blog/detail.html',
        controller: 'blogController',
        controllerAs: 'blog'
      })
      .state('loader', {
        url: '/:lan/loader',
        templateUrl: 'app/views/loader.html',
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontendapp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('frontendapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    //initialize wow library
    new WOW().init();
  }

})();

angular.module("frontendapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"container-fluid\" data-ng-if=\"ready\"><div class=\"back-top\"></div><div class=\"footer\"><div class=\"box\"><p>©2018 Akna • Todos los derechos reservados</p></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"container-fluid menu-header\" data-ng-controller=\"AppController as app\"><div class=\"header row\"><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-class=\"{\'collapsed\':$root.isNavCollapsed}\" ng-click=\"$root.isNavCollapsed = !$root.isNavCollapsed\"><i class=\"fas fa-hamsa\" style=\"margin-right: 10px\"></i> Descubre</button> <a class=\"navbar-brand logo\" ui-sref=\"home({lan: language})\" href=\"\"></a></div><div data-ng-if=\"kandaReady\" class=\"collapse navbar-collapse\" collapse=\"isNavCollapsed\"><ul class=\"nav navbar-nav navbar-right\"></ul><ul class=\"nav navbar-nav navbar-right navbar-fixed-bottom\"><li><a data-ng-click=\"$root.kandaWakeUp(\'intro\')\">Presentación</a></li><li><a data-ng-click=\"$root.showModal(\'modalnumerology\')\">Número de la suerte</a></li><li><a data-ng-click=\"$root.showModal(\'modaltarot\');$root.startDeck()\">Carta del día</a></li><li><a data-ng-click=\"$root.showModal(\'modalcontact\')\">Deja un mensaje</a></li></ul><div class=\"social\" data-ng-if=\"$root.kandaReady\" data-ng-class=\"{\'active\':!isNavCollapsed}\"><a href=\"{{ $root.webcontent.websocial[0].url}}\" target=\"_blank\" class=\"icon facebook\"></a> <a href=\"{{ $root.webcontent.websocial[1].url}}\" target=\"_blank\" class=\"icon instagram\"></a> <a href=\"{{ $root.webcontent.websocial[2].url}}\" target=\"_blank\" class=\"icon youtube\"></a></div></div></div></div></div>");
$templateCache.put("app/views/home.html","<div class=\"pagina\" windowheight=\"\"><div class=\"fullscreen-bg\"><video loop=\"\" muted=\"\" autoplay=\"\" poster=\"../assets/images/background/poster.png\" class=\"fullscreen-bg__video\"><source src=\"../assets/images/background/back1.mp4\" type=\"video/mp4\"></video><audio id=\"waves\" src=\"../assets/images/background/waves.mp4\" autoplay=\"\" loop=\"\"><p>If you are reading this, it is because your browser does not support the audio element.</p></audio></div><ng-include src=\"\'app/views/header.html\'\"></ng-include><div class=\"home-page\" windowheight=\"\"><section class=\"stage\" data-ng-class=\"{\'ready\':kandaReady, \'move\':wrapperMenu}\"><div class=\"waves\" data-ng-class=\"{\'move\':wrapperMenu}\" data-ng-if=\"kandaSpeaking\"></div><div class=\"waves\" data-ng-class=\"{\'on\':kandaHover, \'move\':wrapperMenu}\" data-ng-if=\"kandaHover\"></div><div class=\"waves2\" data-ng-if=\"kandaTransition\"></div><figure class=\"ball\" id=\"ball\"><span class=\"shadow\"></span></figure><div class=\"holder\" windowheight=\"\" data-ng-if=\"kandaHover || kandaSpeaking\" data-ng-controller=\"kaleCtrl as kale\"><canvas id=\"my-canvas\" data-ng-class=\"{\'on\':(kandaHover || kandaSpeaking) , \'move\':wrapperMenu}\" width=\"600\" height=\"600\"></canvas></div></section><a href=\"\" class=\"cta\" data-ng-click=\"$root.showModal(\'modalservice\')\"><i class=\"far fa-comment-dots\" style=\"margin-right: 10px\"></i> Hablame</a> <a href=\"\" data-ng-if=\"$root.kandaReady\" data-ng-click=\"showMenu()\" class=\"btn btn-menu\"><img src=\"../assets/images/menu.svg\" alt=\"\"></a> <a href=\"\" class=\"btn btn-audio\" data-ng-if=\"$root.kandaReady\" data-ng-class=\"{\'stoped\': !$root.audioButton}\" data-ng-click=\"$root.stopAudio()\"><img src=\"../assets/images/sound-on.png\" alt=\"\"></a><form class=\"kanda-form\" windowheight=\"\" data-ng-show=\"!$root.kandaReady\" data-ng-submit=\"$root.introScene()\"><audio id=\"intro\" src=\"../assets/audio/bienvenido.mp3\"></audio><a class=\"btn-start\" data-ng-show=\"!$root.currentScene.status\" data-ng-click=\"kandaWakeUp(\'intro\')\" style=\"color: white;\">Iniciar</a><p class=\"kanda-text wow fadeIn\">{{$root.currentScene.text}}</p><div class=\"input-box\"><input data-ng-model=\"currentUser.name\" type=\"text\" placeholder=\"Ingresa tu nombre\" data-ng-if=\"$root.currentScene.status == \'off\'\" class=\"form-control\"></div><button class=\"btn btn-go\" data-ng-show=\"$root.currentScene.status == \'on\'\" type=\"submit\">Omitir</button> <a href=\"\" class=\"btn btn-audio\" data-ng-class=\"{\'stoped\': !$root.audioButton}\" data-ng-click=\"$root.stopAudio()\"><img ng-src=\"{{\'../assets/images/sound-on.png\'}}\" alt=\"\"></a></form><div class=\"dark\" data-ng-if=\"!$root.kandaReady\" windowheight=\"\"></div><div data-ng-controller=\"AppController as app\" class=\"nots-box\" data-ng-if=\"$root.showNots\"><div class=\"notifications wow bounce\" data-wow-delay=\"2s\"><div class=\"item-image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.webcontent.last.image + \')\'}\" data-ng-mouseover=\"kandaChange($root.api+$root.webcontent.last.image)\" data-ng-mouseleave=\"kandaChange(\'\')\"></div><div class=\"item-abstract\"><h4 data-ng-mouseover=\"kandaChange($root.api+$root.webcontent.last.image )\" data-ng-mouseleave=\"kandaChange(\'\')\">{{$root.webcontent.last.title.es }}</h4><a href=\"\" class=\"btn btn-close\" ng-click=\"setNots();\"><span class=\"glyphicon glyphicon-remove\"></span></a><p data-ng-bind-html=\"$root.webcontent.last.content.es\"></p><a href=\"/blog/{{$root.webcontent.last.webcollection_id+\'/\'+$root.fixNameUrl($root.webcontent.last.name)}}\" class=\"btn btn-more\">Leer más<span class=\"glyphicon glyphicon-menu-right\"></span></a></div></div></div></div><div class=\"wrapper-content\" data-ng-show=\"wrapperMenu\"><div class=\"box-content\" ui-view=\"\" windowheight2=\"\" data-ng-controller=\"blogController as blog\"><a href=\"\" class=\"btn btn-close\" data-ng-click=\"showMenu()\"><span class=\"glyphicon glyphicon-remove\"></span></a><h2 class=\"content-title\">{{(currentUser.name)?currentUser.name+\'. \': \'Hola, \'}} acá puedes encontrar contenido interesante</h2><div class=\"category-item\" data-ng-repeat=\"cat in $root.webcontent.categories\" ui-sref=\"blog({collection:cat.id})\" data-ng-mouseover=\"kandaChange($root.api+cat.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" data-ng-style=\"{\'background\': \'url(\' + $root.api+cat.image + \')\'}\"><div class=\"cat-title\"><h3 data-ng-bind-html=\"cat.title.es\"></h3></div></div></div></div></div>");
$templateCache.put("app/views/loader.html","<div class=\"container-fluid\" data-ng-if=\"!ready\"></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/blog/category.html","<div class=\"box-blog\" ui-view=\"\"><div class=\"breadcrumb\"><span><a href=\"\" data-ng-click=\"stateGoParent()\">Menu</a> / {{$root.webcontent.webcollection.title.es}}</span></div><a href=\"\" class=\"btn btn-close\" data-ng-click=\"showMenu()\"><span class=\"glyphicon glyphicon-remove\"></span></a><div class=\"blog-header\" data-ng-mouseover=\"kandaChange($root.api+$root.webcontent.webcollection.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.webcontent.webcollection.image + \')\'}\"><h3 class=\"blog-title\" data-ng-bind-html=\"$root.webcontent.webcollection.title.es\"></h3><a class=\"btn-kanda-voice\" data-ng-if=\"$root.statusAudioVoice($root.webcontent.webcollection.location) == \'off\'\" data-ng-click=\"$root.playAudioVoice($root.webcontent.webcollection.location)\"><i class=\"far fa-play-circle\"></i></a> <a class=\"btn-kanda-voice\" data-ng-if=\"$root.statusAudioVoice($root.webcontent.webcollection.location) == \'on\'\" data-ng-click=\"$root.stopAudioVoice($root.webcontent.webcollection.location)\"><i class=\"far fa-pause-circle\"></i></a></div><div class=\"blog-text\"><p data-ng-bind-html=\"$root.webcontent.webcollection.content.es\"></p></div><div class=\"blog-subt\"><h4>Articulos</h4></div><div class=\"blog-items\" data-ng-repeat=\"sec in $root.webcontent.webcollection.websection\"><div class=\"item-image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+sec.image + \')\'}\" data-ng-mouseover=\"kandaChange($root.api+sec.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" ui-sref=\"detail({alias:$root.fixNameUrl(sec.name)})\"></div><div class=\"item-abstract\"><small>{{sec.author}} / {{sec.published_at}} {{}}</small><h4 data-ng-mouseover=\"kandaChange($root.api+sec.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" data-ng-bind-html=\"sec.title.es\" ui-sref=\"detail({alias:$root.fixNameUrl(sec.name)})\"></h4><div data-ng-bind-html=\"sec.content.es\"></div><a href=\"\" class=\"btn btn-arrow\" data-ng-mouseover=\"kandaChange($root.api+sec.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" ui-sref=\"detail({alias:$root.fixNameUrl(sec.name)})\"><span class=\"glyphicon glyphicon-menu-right\"></span></a> <a href=\"\" class=\"btn btn-more\" ui-sref=\"detail({alias:$root.fixNameUrl(sec.name)})\">Leer más <span class=\"glyphicon glyphicon-menu-right\"></span></a></div></div></div>");
$templateCache.put("app/views/blog/detail.html","<div class=\"box-blog\" ui-view=\"\" windowheight=\"\"><div class=\"breadcrumb\"><span><a href=\"\" class=\"older\" data-ng-click=\"$root.stateGo(\'home\')\">Menu</a> / <a href=\"\" class=\"older\" data-ng-click=\"stateGoParent()\">{{$root.webcontent.webcollection.title.es}}</a> / {{$root.decodeNameUrl($root.stateParams.alias)}}</span></div><a href=\"\" class=\"btn btn-close\" data-ng-click=\"showMenu()\"><span class=\"glyphicon glyphicon-remove\"></span></a><div class=\"blog-detail-header\"><div class=\"detail-image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.webcontent.websection.image + \')\'}\"></div><div class=\"detail-content\"><h4 class=\"detail-title\">{{$root.webcontent.websection.title.es}}</h4><small>{{$root.webcontent.websection.author}} | {{$root.webcontent.websection.published_at}}</small><div class=\"share\"><a href=\"\"><img src=\"\" alt=\"\"></a></div></div></div><div class=\"article blog-text\" data-ng-repeat=\"sub in $root.webcontent.websection.websectiondata\"><div class=\"content\" data-ng-bind-html=\"sub.content.es\" data-ng-if=\"sub.type==0\"></div><div class=\"row\"><div class=\"col-xs-12\"><img data-ng-if=\"sub.type==1\" style=\"display: block;max-width: 100%;margin: auto\" ng-src=\"{{ $root.api+sub.image }}\" alt=\"\"></div></div><div class=\"announce\" customheight=\"\" equal=\"250\" data-ng-style=\"{\'background\': \'url(\' + $root.api+sub.image + \')\'}\" data-ng-if=\"sub.type==4\"><h3>Título de la publicidad del cliente</h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus quam nulla, pellentesque sed lectus eu, ullamcorper blandit velit.</p></div><div class=\"slider\" data-ng-if=\"sub.type==3\"><ng-owl-carousel class=\"owl-theme gallery-wrapper\" owl-items=\"sub.websectiondataitem\" owl-properties=\"$root.defaultOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" data-ng-repeat=\"item in sub.websectiondataitem\"><img ng-src=\"{{ $root.api+item.image }}\" alt=\"\"></div></ng-owl-carousel></div><div class=\"video\" data-ng-if=\"sub.type==2\"><div class=\"video\" my-youtube=\"\" code=\"sub.link\"></div></div></div></div>");
$templateCache.put("app/views/blog/wrapper.html","<div class=\"wrapper-content\" data-ng-show=\"wrapperMenu\"><div class=\"box-content\" ui-view=\"\" windowheight2=\"\" data-ng-controller=\"blogController as blog\"><a href=\"\" class=\"btn btn-close\" data-ng-click=\"showMenu()\"><span class=\"glyphicon glyphicon-remove\"></span></a><h2 class=\"content-title\">{{(currentUser.name)?currentUser.name+\'. \': \'Hola, \'}} acá puedes encontrar contenido interesante</h2><div class=\"category-item\" data-ng-repeat=\"cat in $root.webcontent.categories\" data-ng-mouseover=\"kandaChange($root.api+cat.image)\" data-ng-mouseleave=\"kandaChange(\'\')\" data-ng-style=\"{\'background\': \'url(\' + $root.api+cat.image + \')\'}\"><a class=\"btn-kanda-voice\" data-ng-if=\"$root.statusAudioVoice(cat.location) == \'off\'\" data-ng-click=\"$root.playAudioVoice(cat.location)\"><i class=\"far fa-play-circle\"></i></a> <a class=\"btn-kanda-voice\" data-ng-if=\"$root.statusAudioVoice(cat.location) == \'on\'\" data-ng-click=\"$root.stopAudioVoice(cat.location)\"><i class=\"far fa-pause-circle\"></i></a><div class=\"cat-title\" ui-sref=\"blog({collection:cat.id})\"><h3>{{cat.title.es}} <i class=\"fas fa-long-arrow-alt-right\"></i></h3></div><div class=\"cat-inv\" ui-sref=\"blog({collection:cat.id})\"></div></div></div></div>");
$templateCache.put("app/views/home/helper.html","<div class=\"dark helper\" data-ng-if=\"$root.kandaHelp\" windowheight=\"\"><a href=\"\" class=\"btn btn-help\" data-ng-if=\"$root.kandaReady\" data-ng-class=\"{\'stoped\': $root.kandaHelp}\" data-ng-click=\"$root.showKandaHelp()\"><i class=\"far fa-question-circle\" style=\"color:white;font-size: 26px;\"></i></a><div class=\"container-fluid menu-header\"><div class=\"header row\"><div class=\"navbar navbar-default\"><div class=\"collapse navbar-collapse\"><ul class=\"nav navbar-nav navbar-right\"></ul><ul class=\"nav navbar-nav navbar-right navbar-fixed-bottom\"><li><a data-ng-click=\"$root.playAudioEffect(\'help_presentacion\')\">Presentación</a></li><li><a data-ng-click=\"$root.playAudioEffect(\'help_fixed\')\">Número de la suerte</a></li><li><a data-ng-click=\"$root.playAudioEffect(\'help_cartas\')\">Carta del día</a></li><li><a data-ng-click=\"$root.playAudioEffect(\'help_contacto\')\">Deja un mensaje</a></li></ul></div></div></div><div class=\"home-page\" windowheight=\"\"><a href=\"\" class=\"cta\" data-ng-click=\"$root.playAudioEffect(\'help_ecommerce\')\"><i class=\"far fa-comment-dots\" style=\"margin-right: 10px\"></i> Hablame</a> <a href=\"\" class=\"btn btn-menu\" data-ng-click=\"$root.playAudioEffect(\'help_blog\')\"><img src=\"../assets/images/menu.svg\" alt=\"\"></a></div></div></div>");
$templateCache.put("app/views/home/kanda.html","<section class=\"stage\" data-ng-class=\"{\'ready\':kandaReady, \'move\':wrapperMenu}\"><div class=\"waves\" data-ng-class=\"{\'move\':wrapperMenu}\" data-ng-if=\"kandaSpeaking\"></div><div class=\"waves\" data-ng-class=\"{\'on\':kandaHover, \'move\':wrapperMenu}\" data-ng-if=\"kandaHover\"></div><div class=\"waves2\" data-ng-if=\"kandaTransition\"></div><figure class=\"ball\" id=\"ball\"><span class=\"shadow\"></span></figure><div class=\"holder\" windowheight=\"\" data-ng-if=\"kandaHover== true || kandaSpeaking == true\" data-ng-controller=\"kaleCtrl as kale\"><canvas id=\"my-canvas\" data-ng-class=\"{\'on\':(kandaHover || kandaSpeaking) , \'move\':wrapperMenu}\" width=\"600\" height=\"600\"></canvas></div></section>");
$templateCache.put("app/views/home/main.html","<div class=\"pagina\" windowheight=\"\"><div class=\"fullscreen-bg\"><video loop=\"\" muted=\"\" autoplay=\"\" poster=\"../assets/images/background/poster.png\" class=\"fullscreen-bg__video\"><source src=\"../assets/images/background/back1.mp4\" type=\"video/mp4\"></video><audio data-ng-if=\"$root.webcontent.categories\" id=\"waves\" src=\"../assets/images/background/waves.mp4\" autoplay=\"\" loop=\"\"></audio><audio id=\"help_blog\" src=\"../assets/audio/voice/help_blog.mp3\"></audio><audio id=\"help_cartas\" src=\"../assets/audio/voice/help_cartas.mp3\"></audio><audio id=\"help_contacto\" src=\"../assets/audio/voice/help_contacto.mp3\"></audio><audio id=\"help_ecommerce\" src=\"../assets/audio/voice/help_ecommerce.mp3\"></audio><audio id=\"help_notificaciones\" src=\"../assets/audio/voice/help_notificaciones.mp3\"></audio><audio id=\"help_presentacion\" src=\"../assets/audio/voice/help_presentacion.mp3\"></audio><audio id=\"help_fixed\" src=\"../assets/audio/voice/help_fixed.mp3\"></audio><audio id=\"bell_1\" src=\"../assets/audio/sounds/bell_1.mp3\"></audio><audio id=\"bell_2\" src=\"../assets/audio/sounds/bell_2.mp3\"></audio><audio id=\"bell_3\" src=\"../assets/audio/sounds/bell_3.mp3\"></audio><audio id=\"whoosh_01\" src=\"../assets/audio/sounds/whoosh_01.mp3\"></audio><audio id=\"whoosh_02\" src=\"../assets/audio/sounds/whoosh_02.mp3\"></audio><audio id=\"whoosh_03\" src=\"../assets/audio/sounds/whoosh_03.mp3\"></audio><audio id=\"whoosh_04\" src=\"../assets/audio/sounds/whoosh_04.mp3\"></audio><audio id=\"whoosh_05\" src=\"../assets/audio/sounds/whoosh_05.mp3\"></audio><audio id=\"whoosh_06\" src=\"../assets/audio/sounds/whoosh_06.mp3\"></audio><div data-ng-if=\"$root.webcontent.categories\" data-ng-repeat=\"cat in $root.webcontent.categories\"><audio id=\"{{cat.location}}\" src=\"{{$root.audioFix(cat)}}\"></audio></div></div><ng-include src=\"\'app/views/header.html\'\" data-ng-if=\"$root.kandaReady\"></ng-include><div class=\"home-page\" windowheight=\"\"><a href=\"\" class=\"cta\" data-ng-if=\"$root.kandaReady\" data-ng-click=\"$root.showModal(\'modalservice\')\"><i class=\"far fa-comment-dots\" style=\"margin-right: 10px\"></i> Hablame</a> <a href=\"\" data-ng-if=\"$root.kandaReady\" data-ng-click=\"showMenu()\" class=\"btn btn-menu\"><img src=\"../assets/images/menu.svg\" alt=\"\"></a> <a href=\"\" class=\"btn btn-help\" data-ng-if=\"$root.kandaReady\" data-ng-class=\"{\'stoped\': $root.kandaHelp}\" data-ng-click=\"$root.showKandaHelp()\"><i class=\"far fa-question-circle\" style=\"color:white;font-size: 26px;\"></i></a> <a href=\"\" class=\"btn btn-audio\" data-ng-if=\"$root.kandaReady\" data-ng-class=\"{\'stoped\': !$root.audioButton}\" data-ng-click=\"$root.stopAudio()\"><img ng-src=\"{{\'../assets/images/sound-on.png\'}}\" alt=\"\"></a><ng-include src=\"\'app/views/home/kanda.html\'\"></ng-include><ng-include src=\"\'app/views/home/presentation.html\'\"></ng-include><ng-include src=\"\'app/views/home/notifications.html\'\" data-ng-if=\"$root.kandaReady\"></ng-include></div><ng-include src=\"\'app/views/blog/wrapper.html\'\"></ng-include><ng-include src=\"\'app/views/home/helper.html\'\"></ng-include></div>");
$templateCache.put("app/views/home/notifications.html","<div data-ng-controller=\"AppController as app\" class=\"nots-box\" data-ng-if=\"$root.showNots\"><div class=\"notifications wow bounce\" data-wow-delay=\"2s\"><div class=\"item-image\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.webcontent.last.image + \')\'}\" data-ng-mouseover=\"kandaChange($root.api+$root.webcontent.last.image)\" data-ng-mouseleave=\"kandaChange(\'\')\"></div><div class=\"item-abstract\"><h4 data-ng-mouseover=\"kandaChange($root.api+$root.webcontent.last.image )\" data-ng-mouseleave=\"kandaChange(\'\')\">{{$root.webcontent.last.title.es }}</h4><a href=\"\" class=\"btn btn-close\" ng-click=\"setNots();\"><span class=\"glyphicon glyphicon-remove\"></span></a><p data-ng-bind-html=\"$root.webcontent.last.content.es\"></p><a href=\"/blog/{{$root.webcontent.last.webcollection_id+\'/\'+$root.fixNameUrl($root.webcontent.last.name)}}\" class=\"btn btn-more\">Leer más<span class=\"glyphicon glyphicon-menu-right\"></span></a></div></div></div>");
$templateCache.put("app/views/home/presentation.html","<div class=\"dark\" data-ng-if=\"!$root.kandaReady\" windowheight=\"\"><form class=\"kanda-form\" windowheight=\"\" data-ng-show=\"!$root.kandaReady\" data-ng-submit=\"$root.introScene()\"><audio id=\"intro\" src=\"../assets/audio/bienvenido.mp3\"></audio><a class=\"btn-start btn-blink\" data-ng-show=\"!$root.currentScene.status\" data-ng-click=\"kandaWakeUp(\'intro\')\" style=\"color: white;\">Iniciar</a><p class=\"kanda-text headphones wow fadeIn\" data-ng-if=\"!$root.currentScene.status\"><i class=\"fas fa-headphones-alt\"></i> Recomendamos el uso de audífonos para esta experiencia</p><p class=\"kanda-text wow fadeIn\">{{$root.currentScene.text}}</p><div class=\"input-box\"><input data-ng-model=\"$root.currentUser.name\" type=\"text\" placeholder=\"Ingresa tu nombre\" data-ng-if=\"$root.currentScene.status == \'off\'\" class=\"form-control\"></div><button class=\"btn btn-go\" data-ng-class=\"{\'btn-blink\':$root.currentUser.name!=\'\'}\" data-ng-show=\"$root.currentScene.status == \'off\'\" type=\"submit\">Aceptar</button> <button class=\"btn btn-go\" data-ng-show=\"$root.currentScene.text && $root.currentScene.status == \'on\'\" type=\"submit\">Omitir</button> <a href=\"\" class=\"btn btn-audio\" data-ng-class=\"{\'stoped\': !$root.audioButton}\" data-ng-click=\"$root.stopAudio()\"><img ng-src=\"{{\'../assets/images/sound-on.png\'}}\" alt=\"\"></a></form></div>");
$templateCache.put("app/views/modals/modalcontact.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"form-wrapper\"><form ng-submit=\"$root.sendForm(3, $root.formData, true)\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">Contacte con Kanda</h3><a href=\"\" class=\"btn btn-close\" data-ng-click=\"$root.closeModal()\"><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=\"modal-body\" id=\"modal-body\"><p style=\"text-align: center\">Llena los siguientes datos por favor.</p><input type=\"text\" placeholder=\"Nombre\" data-ng-model=\"name\" class=\"form-control\"> <input type=\"text\" placeholder=\"Correo\" data-ng-model=\"email\" class=\"form-control\"> <textarea name=\"\" id=\"\" placeholder=\"Mensaje\" class=\"form-control\"></textarea><p><a data-ng-click=\"$root.showTerms()\">Terminos y condiciones</a></p><p class=\"terms\" data-ng-if=\"$root.terms==true\" data-ng-bind-html=\"$root.webcontent.webcontent[11].content.es\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" data-ng-click=\"$root.closeModal()\">Continuar</button></div></form></div></div></div>");
$templateCache.put("app/views/modals/modalnumerology.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid\" customheight=\"\" autoscroll=\"true\"><div class=\"form-wrapper\"><div data-ng-show=\"$root.modalTab == 2\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">{{ $root.webcontent.webcontent[9].content.es}}</h3><a href=\"\" class=\"btn btn-close\" data-ng-click=\"$root.closeModal()\"><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"numerology\"><span class=\"number\">{{$root.currentUser.magic}}</span> <span class=\"number-text\">{{$root.numpick.title.es}}</span></div><p data-ng-bind-html=\"$root.numpick.prediction_1.es\"></p></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"$root.closeModal()\">Continuar</button></div></div><form data-ng-show=\"$root.modalTab == 1\" data-ng-submit=\"$root.magicNumbers()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{$root.webcontent.webcontent[7].content.es}}</h3><a href=\"\" class=\"btn btn-close\" ng-click=\"$root.closeModal()\"><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=\"modal-body\" id=\"modal-body\"><p data-ng-bind-html=\"$root.webcontent.webcontent[8].content.es\"></p><input type=\"date\" data-ng-model=\"$root.currentUser.birthdate\" required=\"\" class=\"form-control\"></div><div class=\"modal-footer\"><button class=\"btn btn-warning\" type=\"submit\">Continuar</button></div></form></div></div></div>");
$templateCache.put("app/views/modals/modalservice.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid modal-family\" customheight=\"\" autoscroll=\"true\"><div class=\"form-wrapper\"><form ng-submit=\"\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">{{$root.webcontent.webcontent[0].content.es}}</h3><a class=\"btn btn-close\" data-ng-click=\"$root.closeModal()\"><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"expert\" data-ng-style=\"{\'background\': \'url(\' + $root.api+$root.webcontent.webcontent[2].file+ \')\'}\"></div><p data-ng-bind-html=\"$root.webcontent.webcontent[1].content.es\"></p><p style=\"text-align:right;font-size: 20px; color: #61298C;\">{{$root.webcontent.webcontent[10].content.es}}</p><p><a data-ng-click=\"$root.showTerms()\">Terminos y condiciones</a></p><p class=\"terms\" data-ng-if=\"$root.terms==true\" data-ng-bind-html=\"$root.webcontent.webcontent[11].content.es\"></p></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" target=\"_blank\" href=\"{{$root.webcontent.webcontent[3].content.es}}\">Comprar</a></div></form></div></div></div>");
$templateCache.put("app/views/modals/modaltarot.html","<div class=\"all-modal dark\"><div class=\"modal-center ta-center container-fluid\" customheight=\"\" autoscroll=\"true\"><div class=\"form-wrapper\" data-ng-init=\"$root.deckReady=false\"><form ng-submit=\"$root.sendForm(3, $root.formData, true)\"><div class=\"modal-header\"><h3 class=\"modal-title\" id=\"modal-title\">{{$root.webcontent.webcontent[4].content.es}}</h3><a class=\"btn btn-close\" data-ng-click=\"$root.closeModal()\"><span class=\"glyphicon glyphicon-remove\"></span></a></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"card-selected\"><img data-ng-if=\"$root.picked\" ng-src=\"{{$root.api+$root.picked.image}}\" alt=\"\"> <a data-ng-click=\"$root.next()\" data-ng-if=\"$root.picked && $root.step == 1\">Ver significado</a><p data-ng-if=\"!$root.picked\">{{$root.webcontent.webcontent[5].content.es}}</p></div><div class=\"result\" data-ng-show=\"$root.step == 2\"><span class=\"card-title\">{{$root.picked.title.es}}</span><p data-ng-bind-html=\"$root.picked.prediction_1.es\"></p></div><div class=\"deck\" data-ng-if=\"$root.step == 1\" data-ng-class=\"{\'start\': $root.deckReady}\"><img data-ng-repeat=\"card in $root.deck\" data-ng-click=\"$root.pickCard(card)\" ng-src=\"{{$root.api+$root.webcontent.webcontent[6].file}}\" alt=\"\" class=\"card\"></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"$root.closeModal()\">Continuar</button></div></form></div></div></div>");}]);